import Login from "../../components/login";
/**
 * LoginPage
 *
 * صفحه ورود کاربران. این صفحه صرفاً کامپوننت Login را رندر می‌کند.
 *
 * @returns JSX.Element
 */

// Task Response:

// کد درست و ساده است و بهینه. نکته‌ای برای بهبود:
// 1. در صورت نیاز به Layout یا متادیتا، می‌توان Login را داخل یک Layout قرار داد.
//    مثال:
//    return <Layout><Login /></Layout>

const LoginPage = () => {
  return <Login />;
};

export default LoginPage;
